import ApplicationComponent from "legacy/ApplicationComponent"
import AuthLauncher from "legacy/auth/AuthLauncher"
import PropTypes from "prop-types"
import React from "react"

import openWorkosAuthPopup from "src/utils/openWorkosAuthPopup"

// Note: $context is loaded globally

// Used inside PaymentAuthController (customer payment auth surface). Reads
// the legacy `window.$context.currentUser` global (set at Rails page-render
// time) to decide which branch to show. After a successful popup login we
// reload the page so $context is repopulated — there's no API to mutate the
// PageContext in place.
class SignInOrLogoutTitleSection extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = { loginError: null }
    this.openLoginPopup = this.openLoginPopup.bind(this)
  }

  componentWillUnmount() {
    this.cancelPopup?.()
  }

  openLoginPopup() {
    this.setState({ loginError: null })
    this.cancelPopup = openWorkosAuthPopup({
      returnTo: window.location.pathname + window.location.search,
      onSuccess: () => {
        window.location.reload()
      },
      onError: (message) => this.setState({ loginError: message }),
    })
  }

  // $context currentUser|UserModel
  render() {
    if ($context.isPresent("currentUser")) {
      return (
        <div>
          <p>
            The {this.props.contextTitle} will be associated with the account{" "}
            {$context.currentUser.email}{" "}
            <a href="/users/sign_out?redirect_back=true">(not you? logout)</a>
          </p>
        </div>
      )
    }
    // WORKOS_AUTH_ENABLED off: fall back to the pre-WorkOS AuthLauncher
    // modal (Devise's /users/sign_in path).
    if (!window.workosAuthEnabled) {
      return (
        <p>
          Have a Dockwa account?{" "}
          <AuthLauncher type="login" customClass="inline" />
        </p>
      )
    }

    return (
      <div className="inline">
        <p>
          Have a Dockwa account?{" "}
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={this.openLoginPopup}
          >
            Log In
          </button>
        </p>
        {this.state.loginError && (
          <p className="text-danger">{this.state.loginError}</p>
        )}
      </div>
    )
  }
}

SignInOrLogoutTitleSection.propTypes = {
  contextTitle: PropTypes.string.isRequired,
}

export default SignInOrLogoutTitleSection
